import React from 'react';
import CccClientHistoryPanel from './CccClientHistoryPanel';

type Props = {
  leadId: string;
  refreshKey?: number;
};

const CccProspeccaoLeadHistory: React.FC<Props> = ({ leadId, refreshKey = 0 }) => (
  <CccClientHistoryPanel workspace="prospeccao" entityId={leadId} refreshKey={refreshKey} />
);

export default CccProspeccaoLeadHistory;
